import yup from 'src/libs/yup';
import { operators } from 'src/utils/helpers';

const oneOfOpearators = operators
  .filter((op) => !!op.value)
  .map((op) => op.value);

export const dateOperatorSchema = yup.object().shape({
  operator: yup
    .string()
    .requiredWhen(yup.ref('value'), 'Data')
    .transform((value) => (value !== '' ? value : null))
    .nullable()
    .oneOf([null, ...oneOfOpearators])
    .label('Operador'),
  value: yup
    .date()
    .nullable()
    .requiredWhen(yup.ref('operator'), 'Operador')
    .when('operator', {
      is: 'between',
      then: (schema) => schema.label('De'),
      otherwise: (schema) => schema.label('Data'),
    }),
  value_end: yup
    .date()
    .nullable()
    .when('operator', {
      is: 'between',
      then: (schema) => schema.required().min(yup.ref('value')),
      otherwise: (schema) => schema.optional(),
    })
    .label('Até'),
});

export const numberOperatorSchema = yup.object().shape({
  operator: yup
    .string()
    .requiredWhen(yup.ref('value'), 'Data')
    .transform((value) => (value !== '' ? value : null))
    .nullable()
    .oneOf([null, ...oneOfOpearators])
    .label('Operador'),
  value: yup
    .string()
    .nullable()
    .requiredWhen(yup.ref('operator'), 'Operador')
    .when('operator', {
      is: 'between',
      then: (schema) => schema.label('De'),
      otherwise: (schema) => schema.label('Data'),
    }),
  value_end: yup
    .string()
    .nullable()
    .when('operator', {
      is: 'between',
      then: (schema) => schema.required(),
      otherwise: (schema) => schema.optional(),
    })
    .label('Até'),
});

const DefaultFilterSchema = yup.object().shape({
  created_at: dateOperatorSchema.optional().label('Data de Criação'),
  updated_at: dateOperatorSchema.optional().label('Data de Alteração'),
  created_by: yup
    .mixed()
    .transform((value) => (value !== '' ? value : null))
    .nullable()
    .label('Criado Por'),
  updated_by: yup
    .mixed()
    .transform((value) => (value !== '' ? value : null))
    .nullable()
    .label('Alterado Por'),
  order_by: yup
    .array()
    .optional()
    .of(
      yup.object().shape({
        column: yup
          .string()
          .requiredWhen(yup.ref('direction'), 'Direção')
          .nullable()
          .label('Coluna'),
        direction: yup
          .string()
          .requiredWhen(yup.ref('column'), 'Coluna')
          .nullable()
          .oneOf([null, 'asc', 'desc'])
          .label('Direção'),
      }),
    )
    .label('Ordenar Por'),
});

export default DefaultFilterSchema;
